export default __webpack_public_path__ + "static/media/LOGOS5.71df4f0f.jpg";